<template>
  <div
    class="product-image h-100"
    v-on="$listeners"
  >
    <img
      v-show="showPlaceholder"
      src="/assets/placeholder.svg"
      :alt="alt"
      class="product-image__placeholder"
    >
    <img
      v-if="!lowerQualityImageError || isOnline"
      v-show="showLowerQuality"
      ref="lQ"
      v-lazy="image.loading"
      :alt="alt"
      class="product-image__thumb"
      @load="imageLoaded('lower', true)"
      @error="imageLoaded('lower', false)"
    >
    <img
      v-if="!highQualityImageError || isOnline"
      v-show="showHighQuality"
      v-lazy="image.src"
      :alt="alt"
      class="product-image__thumb"
      @load="imageLoaded('high', true)"
      @error="imageLoaded('high', false)"
    >
  </div>
</template>

<script>
import { onlineHelper } from '@vue-storefront/core/helpers'

export default {
  props: {
    calcRatio: {
      type: Boolean,
      default: true
    },
    image: {
      type: Object,
      default: () => ({
        src: '',
        loading: ''
      })
    },
    alt: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      lowerQualityImage: false,
      lowerQualityImageError: false,
      highQualityImage: false,
      highQualityImageError: false,
      basic: true
    }
  },
  computed: {
    showPlaceholder () {
      return !this.showLowerQuality && !this.showHighQuality
    },
    showLowerQuality () {
      return this.lowerQualityImage && !this.showHighQuality
    },
    showHighQuality () {
      return this.highQualityImage
    },
    imageRatio () {
      const { width, height } = this.$store.state.config.products.gallery
      return `${height / (width / 100)}%`
    },
    isOnline (value) {
      return onlineHelper.isOnline
    }
  },
  watch: {
    lowerQualityImage (state) {
      if (state) {
        this.basic = this.$refs.lQ.naturalWidth < this.$refs.lQ.naturalHeight;
      }
    }
  },
  methods: {
    imageLoaded (type, success = true) {
      this[`${type}QualityImage`] = success
      this[`${type}QualityImageError`] = !success
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~theme/css/variables/grid';

.product-image {
  position: relative;
  width: 100%;
  max-width: 100%;
  mix-blend-mode: multiply;

  &__placeholder,
  &__thumb {
    height: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    @include mediaQuery(sm) {
      height: auto;
      width: 100%;
    }

    @include mediaQuery(lg) {
      height: 100%;
      width: auto;
    }
  }

  &__placeholder {
    max-width: 50%;
  }
}
</style>
